// ─────────────────────────────────────────────────────────────────────────────
// GENERATED — DO NOT EDIT. Written by scratchpad/sparticus/buckly/b1/scripts/
// gen_placeholders.py from the Claude Design export and the placeholder map:
//   Buckly.dc.html            sha256 904918ed2dc7114088903ca0491f3e94fc04b550afb995a96dd5c2522d585594
//   placeholder_map.tsv (B-0) sha256 6e46cc14358bd0692690a9bf29ba87b17c99b3273d3fc4b2be6b9170a7f3155f
//   map additions (B-1)       sha256 5cf2815b5219026057d788ee50d77d34a060ee83f87f005a58200e42223fe7d1
//
// Every value below is the design's own placeholder (R37), carried verbatim from
// the design's Component source and checked, value by value, against the map.
// In B-4 each panel's values are replaced by live T2 data and the per-panel
// check must then find none of them left. `// L<n>` is the design line.
// ─────────────────────────────────────────────────────────────────────────────
/* eslint-disable */

// L962
export const azure = '95,184,240';

// L962
export const green = '95,211,138';

// L963
export const slipCards = [
      { title: 'Cutting winners early — after a loss', n: 'N=23', body: 'You exit ~40% of the position within 2 minutes specifically on days after a loss — not when the setup is genuinely weaker. On clean days you hold to target.', fill: 92, color: azure, source: 'disposition effect · behavioural-finance canon HIGHEST · your data N=23' },
      { title: 'Size-creep when frustrated', n: 'N=31', body: 'Average size climbs +35% after two consecutive losses — frustration, not a better setup. The setup quality is flat across these; only the size moves.', fill: 50, color: azure, source: 'arousal regulation · sports-psych HIGHEST · your data N=31', highlight: '+35%' },
      { title: 'Forced trades after a loss', n: 'N=44', body: '+2.1 trades per session above baseline immediately after a loss — revenge-pattern. The win-rate on these forced trades is well below your average.', fill: 78, color: green, source: 'tilt / recovery · Tendler mental-game HIGHEST · your data N=44' },
      { title: 'Hold-time compression on tilt', n: 'N=27', body: 'Winners held ~8 min when tilted vs ~19 min in your best state — you grab the money to relieve the discomfort, capping your own upside.', fill: 44, color: azure, source: 'attentional control · sports-psych HIGHEST · your data N=27' },
    ];

// L969
export const bestCards = [
      { title: 'Patience holds at value', n: 'N=38', body: 'In your best state you wait for price to reach value before entering — average 19-min hold, entries at VAH/VAL not mid-range. This is where your expectancy peaks.', fill: 86, color: green, source: 'process focus · sports-psych HIGHEST · your data N=38' },
      { title: 'Flat sizing through drawdown', n: 'N=29', body: 'On your best sessions size stays flat regardless of the prior result — the size button never moves with emotion. Discipline is the constant, not the setup.', fill: 80, color: green, source: 'arousal regulation · sports-psych HIGHEST · your data N=29' },
      { title: 'Three trades, walk away', n: 'N=33', body: 'Best sessions average ~3 trades — you take the A-grades and stop. No boredom trades, no proving anything to the market.', fill: 72, color: green, source: 'selectivity · desk playbook · your data N=33' },
    ];

// L987
export const grn = '95,211,138';

// L987
export const amb = '224,150,52';

// L987
export const rd = '227,103,95';

// L993
export const wallaceRows = [
      { dot: '95,184,240', title: 'At CVD extremes', desc: 'you force counter-trades — the fade-overtrade pattern', vLabel: 'Slip', vColor: rd },
      { dot: grn, title: 'Profile in value', desc: 'your best execution — patient, sized right', vLabel: 'Best', vColor: grn },
      { dot: amb, title: 'Profile out of value', desc: 'you slip — chase the move', vLabel: 'Watch', vColor: amb },
      { dot: amb, title: 'B-shaped vs P-shaped day', desc: 'you over-trade B-shapes (selling tails draw you in)', vLabel: 'Watch', vColor: amb },
    ];

// L999
export const arthurRows = [
      { dot: grn, title: 'DAX indicator entries', desc: 'disciplined — you trust the signal', vLabel: 'Best', vColor: grn },
      { dot: amb, title: 'Gold / NQ price-action', desc: 'more discretion → more drift after a fail', vLabel: 'Watch', vColor: amb },
      { dot: rd, title: 'After a setup fails', desc: 'you re-enter too fast — the forced-trade trigger', vLabel: 'Slip', vColor: rd },
      { dot: grn, title: 'Strategy in strong regime', desc: 'you let winners run — best-state behaviour', vLabel: 'Best', vColor: grn },
    ];

// L1011
export const agendaSrc = [
      { title: 'Size creep after two losing sessions', why: 'Average size rises 35% after two straight losses; Monday\'s 3rd fade went +30%.', source: 'from Patterns · size-creep N=31' },
      { title: 'A reset routine between a loss and the next entry', why: 'Forced trades rise by 2.1 per session straight after a loss.', source: 'from Patterns · forced trades N=44' },
      { title: 'Cutting the runner early', why: 'Review flagged an early exit on Monday\'s winner.', source: 'from Review · Today · slipped' },
    ];

// L1021
export const phaseSrc: [string, string][] = [
      ['Check-in', 'How you arrived today — state, sleep, stress, one word.'],
      ['Bridge from last session', 'What was committed on Tuesday, and what actually happened.'],
      ['Agenda', 'Agree the one or two things worth the time today.'],
      ['The work', 'Explore the pattern, link it to your data, practise a technique.'],
      ['Commitments', 'Two or three concrete actions, each one checkable.'],
      ['Close & summary', 'Key insight, next focus, learnings sent to the Dream Gate.'],
    ];

// L1035
export const baseTurns: [string, string, string][] = [
      ['b', '21:02', 'Before the trades — how are you arriving tonight? One word is fine.'],
      ['o', '21:03', 'Flat. Annoyed, honestly. Two red days and I gave back most of last week.'],
      ['b', '21:04', 'Flat and annoyed, with last week\'s gains feeling undone. When the third fade came up on Monday, what was going through your head as you set the size?'],
      ['o', '21:06', 'That I needed one good one to get back to even. It looked like the cleanest setup of the day, so bigger felt justified.'],
      ['b', '21:07', 'So the size was set by the distance to even, not by the setup. Buckly hears the word "needed" — the trade had a job beyond being a trade.'],
      ['o', '21:08', 'Yeah. Put like that, it was about the scoreboard. And it happens every time I\'m down.'],
      ['b', '21:09', 'That matches your own record: after two losses, average size rises 35% across 31 sessions while setup quality stays flat. Arthur\'s journal shows Monday\'s third fade at +30%. Same pattern, right on schedule.'],
      ['b', '21:11', 'Let\'s build a reset to run between a loss and the next entry — four steps, under two minutes. A process goal, not an outcome goal: the job is the routine, not getting back to even.'],
    ];

// L1050
export const drawing = [
      { label: 'Deep expertise', dot: 'flex:none; width:7px; height:7px; border-radius:50%; background:#e6a23f;', items: [
        { text: 'Process goals over outcome goals — Steenbarger', tag: 'HIGHEST · verified canon', tagColour: '#e6a23f' },
        { text: 'Your tilt map: early warning signs — Tendler', tag: 'HIGHEST · verified canon', tagColour: '#e6a23f' },
        { text: 'Pre-performance reset routine — sports psychology', tag: 'HIGHEST · verified canon', tagColour: '#e6a23f' } ] },
      { label: 'Learned memory', dot: 'flex:none; width:7px; height:7px; border-radius:50%; background:#5fb8f0;', items: [
        { text: 'After two losses you raise size to win it back', tag: 'dreamed · owner-confirmed · 14 Oct', tagColour: '#6fc0f2' },
        { text: 'Your best sessions end at about 3 trades', tag: 'dreamed · owner-confirmed · 2 Oct', tagColour: '#6fc0f2' },
        { text: 'You trade best after a 15-minute wait at the open', tag: 'dreamed · owner-confirmed · 19 Sep', tagColour: '#6fc0f2' } ] },
      { label: "Arthur's data", dot: 'flex:none; width:7px; height:7px; border-radius:50%; background:#5fd6c8;', items: [
        { text: 'Journal, Mon: 3rd fade sized +30%', tag: 'Arthur · journal', tagColour: '#7fdcd0' },
        { text: 'Ledger: forced trades after a loss −0.9R', tag: 'Arthur · ledger', tagColour: '#7fdcd0' },
        { text: 'Ledger: base-size trades after a loss +0.4R average', tag: 'Arthur · ledger', tagColour: '#7fdcd0' } ] },
    ];

// L1064
export const techSteps = [
      { n: '1', title: 'Hands off', body: 'Close the order ticket and stand up — 90 seconds away from the screen.' },
      { n: '2', title: 'Name it', body: 'Say the state out loud: "frustrated, wanting it back."' },
      { n: '3', title: 'Reset size', body: 'Confirm base size on the ticket before looking at a chart.' },
      { n: '4', title: 'Re-qualify', body: 'Re-enter only on an A-grade setup from the playbook; otherwise wait for the next one.' },
    ];

// L1070
export const newCommits = [
      { title: 'Run the four-step reset after every loss', check: "Buckly checks this against Arthur's journal daily" },
      { title: 'Base size on the first trade after any loss', check: "Buckly checks this against Arthur's ledger daily" },
      { title: 'Stop at three trades on a red day', check: "Buckly checks this against Arthur's journal daily" },
    ];

// L1080
export const openCommits = [
      { title: 'Base size after a loss', kept: 'kept 3 of 4 days', pct: 75, k: 'a' },
      { title: 'Sit out the first 15 minutes on news days', kept: 'kept 2 of 2 days', pct: 100, k: 'g' },
      { title: 'Journal the reason for every size change', kept: 'kept 1 of 4 days', pct: 25, k: 'r' },
    ];

// L1085
export const histSrc: [string, string, string, string, string, string, string][] = [
      ['Tue 21:40', 'Debrief', 'Forced trades after the first loss', 'Agreed a three-trade cap on red days.', 'kept 2 of 3', 'a', 'The fourth trade is never about the setup.'],
      ['Fri 18:15', 'Deep session', 'Patience at the open', 'Adopted a 15-minute wait on news days.', 'kept 2 of 2', 'g', 'Waiting is a position, not a missed trade.'],
      ['Wed 20:05', 'Reset after a loss', 'Recovering after a −1.2R morning', 'Walked away; no further trades taken that day.', 'kept 1 of 1', 'g', 'Stopping early protected the week.'],
      ['Mon 21:30', 'Deep session', 'Holding winners to target', 'Wrote a hold-time plan for the runner.', 'kept 1 of 2', 'a', 'Early exits relieve discomfort, not risk.'],
    ];

// L1119
export const subKeys: [string, string][] = [['night', 'Night'], ['week', 'Week'], ['month', 'Month'], ['key', 'Key memory'], ['all', 'All nights']];

// L1124
export const nightCounts: [string, string][] = [['Your words', '14'], ['Sessions', '1'], ["Arthur's journal", '6 entries'], ["Arthur's ledger", '9 trades'], ["Arthur's key learnings", '4'], ['Canon passages', '7']];

// L1126
export const candSrc = [
      { id: 'c1', g: 0, dreamed: 'Mon 26 Oct 03:00', rests: 'Fri 23 · Sun 25 Oct', stance: 'Confirms', about: 'Your trading', seen: 6, text: "Your best sessions start with a 15-minute wait at the open. On Sunday the wait held, and the first trade came at value rather than mid-range.", basis: "your words 2 · sessions 0 · Arthur's journal 2 · Arthur's ledger 3 · Buckly's replies 0", lens: 'Steenbarger — process over outcome' },
      { id: 'c2', g: 0, dreamed: 'Mon 26 Oct 03:00', rests: 'Thu 22 · Fri 23 · Sun 25 Oct', stance: 'New', about: 'You', seen: 4, text: "After a losing session you step up from 0.5% to 1% on the next day's first setup — the urge to win it back arrives before the setup does.", quote: "“I just want one clean one to get back to flat.”", basis: "your words 3 · sessions 1 · Arthur's journal 2 · Arthur's ledger 4 · Buckly's replies 1", lens: 'Tendler — the tilt map' },
      { id: 'c3', g: 0, pref: true, dreamed: 'Mon 26 Oct 03:00', rests: 'Sun 25 Oct', stance: 'New', about: 'Buckly', seen: 3, text: 'Buckly holds any talk of the P&L until the session has closed.', quote: "“Don't talk to me about the P&L until the session's done.”", basis: "your words 1 · sessions 1 · Arthur's journal 0 · Arthur's ledger 0 · Buckly's replies 1", lens: 'Sports psychology — attentional control' },
      { id: 'c4', g: 0, dreamed: 'Mon 26 Oct 03:00', rests: 'Sun 25 Oct', stance: 'New', about: 'Your trading', seen: 1, text: "Possibly the reset routine shortens your hold on the next trade — Sunday's first trade after the reset closed at 6 minutes, against a 19-minute best-state average.", basis: "your words 0 · sessions 1 · Arthur's journal 1 · Arthur's ledger 2 · Buckly's replies 0", lens: 'Sports psychology — pre-performance routine' },
      { id: 'c5', g: 1, dreamed: 'Sat 24 Oct 03:00', rests: 'Tue 20 · Wed 21 · Fri 23 Oct', stance: 'Revises', about: 'Your trading', seen: 5, text: 'Forced trades after a loss cluster in the London–New York overlap, not across the whole session as the earlier key moment had it.', basis: "your words 1 · sessions 0 · Arthur's journal 3 · Arthur's ledger 7 · Buckly's replies 0", lens: 'Steenbarger — the journal as feedback' },
      { id: 'c6', g: 1, dreamed: 'Sat 24 Oct 03:00', rests: 'Thu 22 · Fri 23 Oct', stance: 'New', about: 'You', seen: 2, text: 'Possibly the urge to check the day\'s number mid-session comes right before an oversized entry.', quote: "“I looked at the day's number and thought, one more.”", basis: "your words 2 · sessions 0 · Arthur's journal 1 · Arthur's ledger 2 · Buckly's replies 1", lens: 'Tendler — the tilt map' },
    ];

// L1142
export const groupLabels = ['The night of Sun 25 Oct', 'The night of Fri 23 Oct'];

// L1146
export const becameKey = [{ text: 'Base size on the first trade after a loss held on 3 of 4 days — the reset is taking.', when: 'confirmed Mon 26 Oct 09:12' }];

// L1148
export const weeks = [
      { label: 'Week of Mon 5 Oct', range: 'Mon 5 – Sun 11 Oct', empty: true },
      { label: 'Week of Mon 12 Oct', range: 'Mon 12 – Sun 18 Oct', nNew: 2, nConf: 3, nRev: 0, km: 5, paras: [
        ['What happened', 'A quieter week: four sessions, eleven trades, most of them at base size. The 15-minute wait at the open was used on both news days.'],
        ['New', 'Two new key moments — the best sessions end at about three trades, and early exits relieve discomfort rather than risk.'],
        ['Confirmed', 'Three earlier key moments held: patience at value, flat size through a drawdown, and the open-wait on news days.'],
        ['Cross-reference', 'Lines up with the September key moment on news days — the wait has now held for five straight weeks.']] },
      { label: 'Week of Mon 19 Oct', range: 'Mon 19 – Sun 25 Oct', nNew: 3, nConf: 2, nRev: 1, km: 6, paras: [
        ['What happened', 'Two losing sessions on Monday and Tuesday, then a steadier Wednesday to Sunday. Size crept on the third fade on Monday, and forced trades followed the first loss on Tuesday.'],
        ['New', 'Three new key moments: the step-up in size after a red day, the reset routine as the agreed response, and holding P&L talk until the session has closed.'],
        ['Confirmed and revised', 'The open-wait and the three-trade best session were confirmed again. The forced-trade key moment was revised — it clusters in the London–New York overlap, not the whole session.'],
        ['Cross-reference', 'The size step-up echoes the key moment from the night of Tue 22 Sep — same trigger, smaller this time, and caught one day sooner.']] },
      { label: 'Week of Mon 26 Oct', range: 'Mon 26 Oct – Sun 1 Nov', held: true },
    ];

// L1167
export const monthsSrc = [
      { label: 'September 2026', note: 'written Thu 1 Oct' },
      { label: 'October 2026', note: '3 of 4 weeks rolled up', held: true },
    ];

// L1172
export const sepBars: [string, number, number][] = [['7 Sep', 4, 1], ['14 Sep', 3, 0], ['21 Sep', 5, 2], ['28 Sep', 2, 1]];

// L1181
export const kmSrc: [string, string, number, string, string, string][] = [
      ['After two losses you raise size to win it back.', 'You', 9, 'Fri 23 Oct', 'Tue 13 Oct', 'Wed 14 Oct'],
      ['Your best sessions end at about three trades.', 'Your trading', 7, 'Sun 25 Oct', 'Thu 1 Oct', 'Fri 2 Oct'],
      ['You trade best after a 15-minute wait at the open.', 'Your trading', 8, 'Sun 25 Oct', 'Fri 18 Sep', 'Sat 19 Sep'],
      ['Early exits relieve discomfort, not risk.', 'You', 5, 'Mon 19 Oct', 'Wed 14 Oct', 'Thu 15 Oct'],
      ['Forced trades after a loss cluster in the London–New York overlap.', 'Your trading', 5, 'Fri 23 Oct', 'Tue 20 Oct', 'Wed 21 Oct'],
      ['Patience holds when price is in value.', 'Your trading', 11, 'Sun 25 Oct', 'Mon 7 Sep', 'Tue 8 Sep'],
      ['Size stays flat through a drawdown on your best days.', 'Your trading', 6, 'Thu 22 Oct', 'Sun 13 Sep', 'Mon 14 Sep'],
      ['On news days, forced entries rise unless the open-wait is used.', 'Your trading', 6, 'Wed 21 Oct', 'Thu 10 Sep', 'Fri 11 Sep'],
      ['Frustration shows first as checking the day\'s number.', 'You', 4, 'Fri 23 Oct', 'Sat 3 Oct', 'Sun 4 Oct'],
      ['Saying the state out loud breaks the urge to re-enter.', 'You', 3, 'Sun 25 Oct', 'Tue 20 Oct', 'Wed 21 Oct'],
      ['Open questions land better than advice straight after a loss.', 'Buckly', 4, 'Tue 20 Oct', 'Fri 25 Sep', 'Sat 26 Sep'],
      ['A short check-in before the open steadies the first trade.', 'Buckly', 5, 'Mon 19 Oct', 'Mon 21 Sep', 'Tue 22 Sep'],
      ['DAX indicator entries are executed with the most discipline.', 'Your trading', 7, 'Thu 22 Oct', 'Wed 2 Sep', 'Thu 3 Sep'],
      ['After a failed setup you re-enter too fast.', 'Your trading', 8, 'Tue 20 Oct', 'Tue 8 Sep', 'Wed 9 Sep'],
      ['B-shaped days draw you into over-trading the tails.', 'Your trading', 4, 'Fri 16 Oct', 'Mon 28 Sep', 'Tue 29 Sep'],
      ['Holding the runner to target is easier with a written hold plan.', 'Your trading', 3, 'Mon 19 Oct', 'Mon 12 Oct', 'Tue 13 Oct'],
      ['Sleep under six hours comes before the heaviest sizing days.', 'You', 4, 'Wed 14 Oct', 'Thu 17 Sep', 'Fri 18 Sep'],
      ['Stopping after a −1R morning protects the week.', 'Your trading', 3, 'Wed 21 Oct', 'Tue 6 Oct', 'Wed 7 Oct'],
      ['Wins after a deviation get logged as a process miss, not a success.', 'Buckly', 5, 'Mon 19 Oct', 'Thu 24 Sep', 'Fri 25 Sep'],
      ['The urge to win it back arrives before the setup does.', 'You', 6, 'Fri 23 Oct', 'Sun 27 Sep', 'Mon 28 Sep'],
      ['Strong-regime days let winners run without prompting.', 'Your trading', 5, 'Thu 22 Oct', 'Wed 16 Sep', 'Thu 17 Sep'],
      ['Mid-session reviews work better as one line than a list.', 'Buckly', 3, 'Sun 18 Oct', 'Fri 9 Oct', 'Sat 10 Oct'],
      ['A three-trade cap on red days is kept more often than not.', 'Your trading', 3, 'Sun 25 Oct', 'Tue 20 Oct', 'Wed 21 Oct'],
    ];

// L1211
export const prefs: [string, string][] = [
      ["“Ask me how I'm arriving before you show me anything.”", 'Tue 6 Oct'],
      ["“One line mid-session. Save the rest for the debrief.”", 'Sat 10 Oct'],
      ["“If I've had two losses, tell me straight — don't soften it.”", 'Wed 14 Oct'],
      ["“Use my words for the patterns, not textbook labels.”", 'Thu 22 Oct'],
    ];

// L1218
export const nightSrc: [string, string, string, string, number, null | number, null | number, string?][] = [
      ['Sun 25 Oct', 'Mon 26 Oct 03:00', 'Completed', 'g', 4, null, null],
      ['Sat 24 Oct', 'Sun 25 Oct 03:00', 'Quiet', 'n', 0, 0, 0, 'Nothing became a learning this night.'],
      ['Fri 23 Oct', 'Sat 24 Oct 03:00', 'Completed', 'g', 3, 2, 1],
      ['Thu 22 Oct', 'Fri 23 Oct 03:00', 'Completed', 'g', 3, 0, 2],
      ['Wed 21 Oct', 'Thu 22 Oct 03:00', 'Completed', 'g', 2, 0, 2],
      ['Tue 20 Oct', 'Wed 21 Oct 03:00', 'Completed', 'g', 4, 0, 3],
      ['Mon 19 Oct', 'Tue 20 Oct 03:00', 'Failed', 'r', 0, 0, 0, 'The dream that night failed — the next night covers it.'],
      ['Sun 18 Oct', 'Mon 19 Oct 03:00', 'Completed', 'g', 2, 0, 1],
      ['Sat 17 Oct', '—', 'No dream', 'n', 0, 0, 0, 'There was no dream the night of Sat 17 Oct.'],
      ['Fri 16 Oct', 'Sat 17 Oct 03:00', 'Completed', 'g', 3, 0, 2],
      ['Thu 15 Oct', 'Fri 16 Oct 03:00', 'Completed', 'g', 2, 0, 1],
      ['Wed 14 Oct', 'Thu 15 Oct 03:00', 'Completed', 'g', 3, 0, 2],
      ['Tue 13 Oct', 'Wed 14 Oct 03:00', 'Completed', 'g', 2, 0, 2],
      ['Mon 12 Oct', 'Tue 13 Oct 03:00', 'Completed', 'g', 1, 0, 1],
    ];

// L1238
export const dreamRules = ['Nothing becomes memory until you confirm it — never by time or silence.', 'Rejected is gone — never used, never shown again.', 'Nothing is ever deleted — older versions are kept as history.', "The dream never writes canon — the Therapist Area's canon is yours alone.", "Numbers come only from Arthur's records, never from Buckly's own words.", 'Arthur is read only — Buckly never writes into Arthur.'];

// L1010 — the session-type labels (the array literal on the line)
export const SESS_TYPES = ['Deep session', 'Debrief', 'Reset after a loss'];

// L1045
export const TURN_WHO_BUCKLY = 'Buckly';

// L1045
export const TURN_WHO_YOU = 'You';

// L1031
export const PHASE_NOW = 'Now';

// L1031
export const PHASE_DONE = 'Done';

// L1031
export const PHASE_NEXT = 'Next';

// L1098
export const AGENDA_COUNT_SUFFIX = ' on agenda';

// L1103
export const TYPE_BTN_VOICE = 'Use voice instead';

// L1103
export const TYPE_BTN_TYPE = 'Type instead';

// L1105
export const STATUS_IN_SESSION = 'In session · ';

// L1105
export const STATUS_OPEN_COMMITS = ' · 3 commitments open';

// L1105
export const STATUS_READY = 'Ready · last session Tue 21:40 · 3 commitments open';

// L1107
export const SESS_HEAD_STARTED = ' · started 21:02';

// L1109
export const DREAM_LABEL_SENT = '✓ Sent · awaiting your confirmation';

// L1109
export const DREAM_LABEL_SEND = 'Send learnings to the Dream Gate';

// L1123
export const CHEV_OPEN = '▾';

// L1123
export const CHEV_SHUT = '▸';

// L1143
export const CAND_GROUP_WAITING = ' waiting';

// L1146
export const BECAME_JUST_NOW = 'confirmed just now';

// L1146
export const BECAME_C1_WHEN = 'confirmed Mon 26 Oct 09:12';

// L1165
export const WEEK_SOURCE_PREFIX = 'built from key moments only · ';

// L1165
export const WEEK_SOURCE_KM = ' key moments · ';

// L1176
export const MONTH_TITLE = 'Monthly reflection · September 2026';

// L1176 — the month's paragraphs (the array after `paras:`)
export const MONTH_PARAS = [
      { title: 'Through-line', text: 'September was the month the size button stopped moving with the last result. The pattern still showed up, but it was caught earlier each week.', src: 'from 4 weekly reflections · 7 Sep – 4 Oct' },
      { title: 'What changed', text: 'Forced trades after a loss fell from about two per session to under one, and the step-up in size after a red day shrank from 1% to 0.75%.', src: "numbers from Arthur's ledger · 4 weekly reflections" },
      { title: 'What held', text: 'Patience at value and the 15-minute wait at the open held every week. Best sessions kept ending at about three trades.', src: 'from 4 weekly reflections · 14 key moments' },
      { title: "What's compounding", text: 'Each week the frustration trigger was named sooner. The reset routine is the next thing to build on, and the next month will show whether it holds under a losing streak.', src: 'from 4 weekly reflections · 3 revised key moments' } ];

// L1206
export const LENS_BUCKLY = 'Sports psychology — coaching under pressure';

// L1206
export const LENS_YOU = 'Tendler — the tilt map';

// L1206
export const LENS_TRADING = 'Steenbarger — process over outcome';

// L1206
export const ABOUT_BUCKLY = 'Buckly';

// L1206
export const ABOUT_YOU = 'You';

// L1208
export const KM_BASIS_WORDS = "your words ";

// L1208
export const KM_BASIS_SESSIONS = " · sessions ";

// L1208
export const KM_BASIS_JOURNAL = " · Arthur's journal ";

// L1208
export const KM_BASIS_LEDGER = " · Arthur's ledger ";

// L1234
export const NIGHT_PREFIX = 'Night of ';

// L1234
export const NIGHT_NOT_DREAMED = 'not dreamed';

// L1234
export const NIGHT_DREAMED = 'dreamed ';

// L1235
export const NIGHT_LINK_CLOSE = "Close night's page";

// L1235
export const NIGHT_LINK_OPEN = "Night's page →";

// L1236
export const NIGHT_PAGE_DASH = ' — ';

// L1236
export const NIGHT_PAGE_WAITING = ' learnings waiting, ';

// L1236
export const NIGHT_PAGE_CONFIRMED = ' confirmed.';

// L1242
export const WAITING_LABEL_SUFFIX = ' waiting · they pile up — no rush';

// L1243
export const BECAME_COUNT_SUFFIX = ' confirmed';

// L1244
export const NIGHT_PAGE_LINE_PREFIX = 'Night of Sun 25 Oct — ';

// L1261
export const PAT_INTRO_SLIPS = 'These are the things invisible from inside the trade.';

// L1261
export const PAT_INTRO_BEST = 'This is the state your edge runs best in — protect it.';

// L1272
export const REV_WEEK_TITLE = 'This week';

// L1272
export const REV_DESIGNED_NEXT = 'Designed next';

// L1273
export const REV_MONTH_TITLE = 'This month';

// L922 — the design's initial component state (c1 is pre-confirmed in it)
export const DESIGN_STATE = { tab: 'today', patSub: 'slips', revSub: 'today', sessType: 0, agendaOn: [true, true, false], phase: 3, call: false, typeMode: false, draft: '', extra: [], dream: false, histOpen: -1, dSub: 'night', folded: {}, cand: { c1: 'confirmed' }, weekIdx: 2, monthIdx: 1, kmOpen: -1, nightOpen: -1 };
